var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fission-shareSheet-wrapper"},[_c('MobileShare',{ref:"mobileShare",attrs:{"hasCallback":"","moduleName":"fission","getContainer":".fission-public-share"},on:{"copy-fail":_vm.copyFail,"copy-success":_vm.copySuccess,"to-share":_vm.toShare,"onshow":_vm.popupShow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }